import { FaviconPaths } from "~/lib/Favicon";
import { create } from "zustand";

interface FaviconPathsStore {
  faviconPaths: FaviconPaths;
  setFaviconPaths: (faviconPaths: FaviconPaths) => void;
}

export const useFaviconPathsStore = create<FaviconPathsStore>()((set) => ({
  faviconPaths: {},
  setFaviconPaths: (faviconPaths: FaviconPaths) => set({ faviconPaths }),
}));
